<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-layout justify-center>
          <v-flex xs10 sm6 md6>
            <v-card tile>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-img width="100%" src="@/assets/images/image_main.jpg"/>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </v-container>

</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data: () => ({
    user: {},
    role: {}

  }),
  components: {
  },
  mounted () {
    this.user = this.$cookies.get('user')
    this.role = JSON.parse(localStorage.getItem('permisos'))
  },
  methods: {
    ...mapActions([]),
    ...mapMutations([])
  },
  computed: {
    ...mapGetters([])
  }
}
</script>
